export const repoQueryKey = (owner: string, repo: string) => ['repo', owner, repo] as const;
export const issuesQueryKey = (repoDid: string) => ['issues', repoDid] as const;
export const issueQueryKey = (repoDid: string, issueRef: string) => ['issue', repoDid, issueRef] as const;
export const pullsQueryKey = (repoDid: string) => ['pulls', repoDid] as const;
export const pullQueryKey = (repoDid: string, pullRef: string) => ['pull', repoDid, pullRef] as const;
export const pullPatchQueryKey = (pullUri: string, roundIndex: number) => ['pull-patch', pullUri, roundIndex] as const;
